// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"ec3041e4","348":"8b5b89c4","571":"ecbbe540","924":"128a0b7c"}[chunkId] + ".chunk.js";
};